import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Server06 = function Server06(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20 12c0 4.4183-3.5817 8-8 8m8-8c0-4.4183-3.5817-8-8-8m8 8H4m8 8c-4.4183 0-8-3.5817-8-8m8 8a12.24 12.24 0 0 0 3.2006-8A12.24 12.24 0 0 0 12 4m0 16a12.24 12.24 0 0 1-3.1995-8A12.24 12.24 0 0 1 12 4m-8 8c0-4.4183 3.5817-8 8-8M6 20c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m16 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2M6 4c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2m16 0c0 1.1046-.8954 2-2 2s-2-.8954-2-2 .8954-2 2-2 2 .8954 2 2"
    })
  }));
};
export default Server06;